import React from 'react'
import { Button } from 'reactstrap'
import PaginatedListCard from '../common/PaginatedListCard'

function UsersListCard({
  users,
  isLoadingUsers,
  usersError,
  onRefresh,
  onEdit,
  canEdit = true,
  page,
  totalPages,
  totalElements,
  size,
  onPageChange,
  onSizeChange,
}) {
  const safeUsers = Array.isArray(users) ? users : []
  const columns = canEdit
    ? ['ID', 'Usuario', 'Rol', 'Mayorista', 'Acciones']
    : ['ID', 'Usuario', 'Rol', 'Mayorista']
  const rows = safeUsers.map((user) => ({
    key: user.id,
    cells: [
      user.id,
      user.username,
      user.role,
      user.wholesaler || '-',
      ...(canEdit
        ? [
            <Button color="primary" size="sm" onClick={() => onEdit(user)}>
              Editar
            </Button>,
          ]
        : []),
    ],
  }))

  return (
    <PaginatedListCard
      title="Listado de usuarios"
      isLoading={isLoadingUsers}
      error={usersError}
      onRefresh={onRefresh}
      emptyMessage="No hay usuarios registrados."
      columns={columns}
      rows={rows}
      page={page}
      totalPages={totalPages}
      totalElements={totalElements}
      size={size}
      onPageChange={onPageChange}
      onSizeChange={onSizeChange}
      pageSizeId="page-size"
    />
  )
}

export default UsersListCard
